<template>
  <div class="w-100 mb-100">

    <!--escritorios-->
    <div class="m-auto container-text-flavors d-none d-sm-none d-md-block">
      <div v-if="show_text" class="row">
        <div class="col text-flavors-home color-blue mt-20">
          <HomeText/>
        </div>
      </div>

      <div id="sabores" class="text-center mt-20">
        <v-btn
          color="accent"
          text
          :class="`${category_selected == 'all' ? 'border-b' : ''} btn-flavors mr-2`"
          @click="filterFlavor('all')"
        >
          TODOS
        </v-btn>
        <v-btn
          v-for="cat of categories_flavors"
          :key="cat.id"
          color="accent"
          text
          :class="`${category_selected == cat.key_ ? 'border-b' : ''} btn-flavors`"
          @click="filterFlavor(cat.key_, cat.id)"
        >
          {{cat.name.toUpperCase()}}
        </v-btn>
        <div class="row mt-50 background-flavors" :key="copy_flavors.length" v-if="copy_flavors.length" :style="[{'background-image': 'url(' + require('@/assets/sabores/FONDO_SABORES.png') + ')'},{'background-size':  `${copy_flavors.length <= 6 ? 65 : 100}%`}]">
          <div
            class="flavor_list col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-50"
            v-for="(item, index) in copy_flavors"
            :key="index"
          >
            <ItemSlideFlavor
              @addCart="openSnack"
              :active="false"
              :item="item"
            />
          </div>
        </div>
      </div>
    </div>

    <!--moviles-->
    <div class="d-block d-sm-block d-md-none">
      <div class="text-left">
        <div class="container">
          <div v-if="show_buttons" class="buttons-filter-home mb-5">
            <v-btn
              color="accent"
              text
              :class="`${category_selected == 'all' ? 'border-b' : ''} btn-flavors mr-2`"
              @click="filterFlavor('all')"
              style="padding: 5px"
            >
              TODOS
            </v-btn>
            <v-btn
              v-for="cat of categories_flavors"
              :key="cat.id"
              color="accent"
              text
              :class="`${category_selected == cat.key_ ? 'border-b' : ''} btn-flavors mr-2`"
              @click="filterFlavor(cat.key_, cat.id)"
              style="padding: 5px;"
            >
              {{cat.name.toUpperCase()}}
            </v-btn>
          </div>
        </div>

        <div class="row mt-50" :key="copy_flavors.length" v-if="copy_flavors.length">
          <v-sheet
            elevation="0"
            class="container-products-mobile"
            color="light"
          >
            <v-slide-group
              v-model="slide"
              class="pa-4"
              center-active
            >
              <v-slide-item
                v-for="item of copy_flavors"
                :key="item.id"
                class="mr-10"
              >
                <ItemFlavorMobile
                  @addCart="openSnack"
                  :active="false"
                  :item="item"
                />
              </v-slide-item>
            </v-slide-group>
          </v-sheet>

        </div>
      </div>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="40"
      ></v-progress-circular>
    </v-overlay>

    <SnackbarCart ref="snackbarCart"/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import ItemSlideFlavor from '@/components/store/ItemSlideFlavor'
import ItemFlavorMobile from '@/components/store/mobile/ItemFlavorMobile'
import HomeText from '@/components/store/HomeText'

export default {
  props: ['categories_flavors', 'show_buttons', 'show_text'],
  components: { ItemSlideFlavor, ItemFlavorMobile, HomeText },
  data: () => ({
    slide: null,
    category_selected: 'all',
    tab: null,
    copy_flavors: [],
    flavors: [],
    overlay: false,
    toggle_exclusive: undefined
  }),
  watch: {
    'data_home_page.flavors': {
      handler(newval) {
        this.copy_flavors = newval
        this.flavors = newval
      },
      deep: true
    }
  },
  methods: {
    openSnack() {
      this.$refs.snackbarCart.open()
    },
    filterFlavor(key, id = 0) {
      this.category_selected = key
      this.overlay = true
      setTimeout(() => {
        if (key == 'all') {
          this.copy_flavors = this.flavors
        } else {
          this.copy_flavors = this.flavors.filter(i => {
            return i.category_flavor.id == id
          })
        }
        this.overlay = false
      }, 500)
    },
    getAddToCart(product_id) {
			let match = false
			let item_qty
			this.cart.cart_products.forEach(i => {
				if (i.product.id == product_id) {
					match = true
					item_qty = i.quantity
				}
			})
			return {
				match: match,
				text: `Agregado al carrito x ${item_qty}`,
			}
    }
  },
  mounted() {
    this.copy_flavors = this.data_home_page.flavors
    this.flavors = this.data_home_page.flavors
  },
  computed: {
    ...mapState(['data_home_page', 'cart'])
  }
}
</script>

<style scoped>
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color: var(--color-tertiary) !important
  }
  .btn-flavors {
    border-radius: 0;
  }
  .border-b {
    border-bottom: 2px solid var(--color-tertiary);
  }
  >>>.v-btn__content {
    font-size: 16px;
  }
  .background-flavors {
    background-position: center center;
    background-repeat:  no-repeat;
  }
</style>
